export const getEmailFooterModeStorageKey = (conversationId: string) => `gc-email-footer-mode-${conversationId}`;
export const getEmailDraftStorageKey = (conversationId: string) => `gc-email-${conversationId}`;
